import React from 'react';
import { Popup } from './Popup';

interface ContactPopupProps {
  visible: boolean;
  onClose: () => void;
}

const PHONE_CONTACTS = [
  { number: '0976.428.986', tel: '0976428986', name: 'Ngân' },
  { number: '0984.011.103', tel: '0984011103', name: 'Nhung' },
];

const PhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className="w-5 h-5 flex-shrink-0 text-[#5A4099]"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.36 11.36 0 003.58.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.57 3.58 1 1 0 01-.24 1.01l-2.21 2.2z" />
  </svg>
);

const LocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className="w-5 h-5 flex-shrink-0 text-[#5A4099]"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5A2.5 2.5 0 1114.5 9 2.5 2.5 0 0112 11.5z" />
  </svg>
);

export const ContactPopup: React.FC<ContactPopupProps> = ({
  visible,
  onClose,
}) => {
  return (
    <Popup
      visible={visible}
      onCancel={onClose}
      title={
        <span className="block text-left pr-6 font-medium text-[#3b3b3b]">
          Thành viên đầu tư có thắc mắc xin mời liên hệ
        </span>
      }
      footer={null}
      width={360}
    >
      <div className="text-[#3b3b3b] text-sm leading-relaxed space-y-4 pb-2">
        <div>
          <div className="flex items-center gap-2 font-bold mb-2">
            <PhoneIcon />
            <span>Số điện thoại:</span>
          </div>
          <ul className="list-disc pl-10 space-y-1">
            {PHONE_CONTACTS.map((contact) => (
              <li key={contact.tel}>
                <a
                  href={`tel:${contact.tel}`}
                  className="text-[#5A4099] font-medium"
                >
                  {contact.number}
                </a>
                {` (${contact.name})`}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="flex items-center gap-2 font-bold mb-2">
            <LocationIcon />
            <span>Địa chỉ:</span>
          </div>
          <p className="pl-7">
            Tầng 3, Tòa Savina, Số 1 Đinh Lễ, Hoàn Kiếm, Hà Nội
          </p>
        </div>
      </div>
    </Popup>
  );
};

export default ContactPopup;
